import axios from 'axios';

import { extractData, logError, toSnakeCase } from '@/api/ApiHelpers';

import type {
	ApiPayload,
	EmailSettingsResponse,
	EmailSettingsUpdatePayload,
	LinkedEmailAccount,
	LinkedEmailListResponse,
} from '@/api/ApiTypes';


const alertsEmailSettingsGet = (
	handler: (data: EmailSettingsResponse) => void,
): void => {
	axios.get('/alerts/email/settings/').then(extractData(handler)).catch(logError);
};


const alertsEmailSettingsPost = (
	data: EmailSettingsUpdatePayload,
	handler: (data: EmailSettingsResponse) => void,
): void => {
	axios.post('/alerts/email/settings/update/', data).then(extractData(handler)).catch(logError);
};


const alertsEmailTest = (
	recipientEmail: string,
	handler: (data: ApiPayload) => void,
): void => {
	axios.post('/alerts/email/test/', { recipient_email: recipientEmail }).then(extractData(handler)).catch(logError);
};


const alertsEmailAccountsGetList = (
	handler: (data: LinkedEmailListResponse) => void,
): void => {
	axios.get('/alerts/email/accounts/get_list/').then(extractData(handler)).catch(logError);
};


const alertsEmailAccountsCreate = (
	email: string,
	handler: (data: ApiPayload) => void,
): void => {
	axios.post('/alerts/email/accounts/create/', { email }).then(extractData(handler)).catch(logError);
};


const alertsEmailAccountsUpdate = (
	data: LinkedEmailAccount,
	handler: (data: ApiPayload) => void,
): void => {
	axios.post('/alerts/email/accounts/update/', toSnakeCase(data)).then(extractData(handler)).catch(logError);
};


const alertsEmailAccountsDelete = (
	email: string,
	handler: (data: ApiPayload) => void,
): void => {
	axios.post('/alerts/email/accounts/delete/', { email }).then(extractData(handler)).catch(logError);
};


const alertsEmailAccountsTest = (
	email: string,
	handler: (data: ApiPayload) => void,
): void => {
	axios.post('/alerts/email/accounts/test/', { email }).then(extractData(handler)).catch(logError);
};


const alertsEmailAccountsVerificationStatus = (
	email: string,
	handler: (data: ApiPayload & { verified?: boolean }) => void,
): void => {
	axios.post('/alerts/email/accounts/verification_status/', { email }).then(extractData(handler)).catch(logError);
};


const alertsEmailAccountsResendVerification = (
	email: string,
	handler: (data: ApiPayload) => void,
): void => {
	axios.post('/alerts/email/accounts/resend_verification/', { email }).then(extractData(handler)).catch(logError);
};


const alertsEmailAccountsVerify = (
	code: string,
	handler: (data: ApiPayload & { email?: string; verified?: boolean }) => void,
	errorHandler?: (error: unknown) => void,
): void => {
	axios.post('/alerts/email/accounts/verify/', { code }).then(extractData(handler)).catch(errorHandler || logError);
};


export default {
	alertsEmailSettingsGet,
	alertsEmailSettingsPost,
	alertsEmailTest,
	alertsEmailAccountsGetList,
	alertsEmailAccountsCreate,
	alertsEmailAccountsUpdate,
	alertsEmailAccountsDelete,
	alertsEmailAccountsTest,
	alertsEmailAccountsVerificationStatus,
	alertsEmailAccountsResendVerification,
	alertsEmailAccountsVerify,
};
